import { Button, Card, Container, Group, Text } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';
import { useSubscription } from '@melio/subscriptions-sdk';
import { usePlanInfo, useSubscriptionRouter } from '@melio/subscriptions-ui';

export const FreePlanCard = () => {
  const { goToSubscriptionPlans } = useSubscriptionRouter();
  const { formatMessage } = useMelioIntl();

  const { subscription } = useSubscription();

  const { planName } = usePlanInfo({ planId: subscription.planId });

  return (
    <Card variant="flat" paddingX="m" paddingY="m" data-testid="subscription-basic-plan">
      <Group width="full" justifyContent="space-between" alignItems="center" spacing="s">
        <Container alignItems="center">
          <Text textStyle="body2Semi">{planName}</Text>
        </Container>

        <Button
          data-testid="subscription-basic-plan-upgrade"
          label={formatMessage('widgets.subscriptionPlanSettings.upgradePlan')}
          onClick={() => {
            goToSubscriptionPlans({ returnUrl: '/settings/subscription-plans' });
          }}
        />
      </Group>
    </Card>
  );
};
